// extracted by mini-css-extract-plugin
module.exports = {"label":"AreaTooltip_label__g5udc","value":"AreaTooltip_value__3hQFC","wrapper":"AreaTooltip_wrapper__HjMe3"};